import { setFiltersToQs } from './set-filters-to-qs';

export const buildPathWithFilters = <T extends object>(path: string, filters: T): string => {
  const qs = new URLSearchParams();
  setFiltersToQs<T>(qs, filters);

  const search = qs.toString();
  return search ? `${path}?${search}` : path;
};
